<template>
    <div class="p-4 rounded-lg shadow-xl">
        <div class="flex items-center">
            <div class="flex-shrink-0">
                <i :class="`${icon} fa-2x text-white`"></i>
            </div>
            <div class="ml-3">
                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-6" v-if="label1">
                        <h3 class="lg:whitespace-nowrap whitespace-normal text-xs leading-6 font-medium text-white">
                            {{ label1 }}
                        </h3>
                        <p class="mt-1 text-sm leading-5 text-white whitespace-nowrap">
                            {{ value1 }}
                        </p>
                    </div>
                    <div class="col-span-6" v-if="label2">
                        <h3 class="lg:whitespace-nowrap whitespace-normal text-xs leading-6 font-medium text-white">
                            {{ label2 }}
                        </h3>
                        <p class="mt-1 text-sm leading-5 text-white whitespace-nowrap">
                            R$ {{ value2 | currency }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label1: { type: String, default: '' },
        label2: { type: String, default: '' },
        value1: { type: Number, default: 0 },
        value2: { type: Number, default: 0 },
        icon: { type: String, required: true },
    }
}
</script>
